package ui.eReceipt.receiptTypes

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.clearAndSetSemantics
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import formatDecimalToCurrency
import kotlinx.coroutines.flow.StateFlow
import model.MerchantFullInformationV3
import receipt.Receipt
import toContentDescription
import ui.eReceipt.components.Balance
import ui.eReceipt.components.DejavooOrderInformation
import ui.eReceipt.components.LocationTitleBanner
import ui.eReceipt.components.SpacedTextDisplay

@Composable
fun DejavooReceipt(
    maxWidth: Dp,
    eReceipt: Receipt,
    merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?>?,
    loggedInCustomerIdMatchesReceiptCustomerId: Boolean,
    isSimplified: Boolean = false,
) {
    HorizontalDivider(
        modifier = Modifier
            .widthIn(0.dp, maxWidth),
        color = Color.White,
        thickness = 32.dp
    )
    if (!isSimplified) {
        LocationTitleBanner(eReceipt.locationDetails, maxWidth)
    }
    Box(
        modifier = Modifier
            .widthIn(0.dp, maxWidth)
            .background(Color.White)
    ) {
        DejavooOrderInformation(eReceipt)
    }

    eReceipt.paymentDetails["Total"]?.let {
        Column(
            modifier = Modifier
                .widthIn(0.dp, maxWidth)
                .background(Color.White)
        ) {
            Spacer(modifier = Modifier.height(12.dp))
            SpacedTextDisplay(
                label = "Total",
                amount = it.formatDecimalToCurrency(),
                Modifier.padding(horizontal = 20.dp, vertical = 4.dp)
                    .clearAndSetSemantics {
                        contentDescription = toContentDescription(
                            "Total",
                            it.formatDecimalToCurrency()
                        )
                    },
                color = Color.Black,
                fontWeight = FontWeight.Bold,
            )
        }
    }

    if (!isSimplified) {
        if (merchantInformationStateFlow != null) {
            Balance(
                eReceipt.rewardBalanceMessage,
                merchantInformationStateFlow,
                loggedInCustomerIdMatchesReceiptCustomerId,
                maxWidth
            )
        }
    }
}